// Configurações dos Request do Axio
import axios from 'axios';
import { API_CONFIG } from '@/config/api';
import { SessionManager } from '@/utils/sessionManager';

// Criar instância do axios com configuração base
export const api = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: 30000, // 30 segundos para uploads
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para requests
api.interceptors.request.use(
  (config) => {
    // Incluir token de autenticação automaticamente
    const token = SessionManager.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log da requisição em desenvolvimento
    if (import.meta.env.DEV) {
      console.log(`BACKEND Axios Interceptou este Request: ${config.method?.toUpperCase()} ${config.url}`);
      console.log('BACKEND Request Config:', config);
      console.log('BACKEND Request Data:', config.data);
      console.log('BACKEND Authorization Header:', config.headers.Authorization ? 'Token incluído' : 'Sem token');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para responses
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Verificar se o erro é 401 (não autorizado) e limpar token inválido
    if (error.response?.status === 401) {
      const token = SessionManager.getToken();
      if (token) {
        SessionManager.clearTokensDirectly();
        SessionManager.clearSession();

        // Opcional: redirecionar para login ou recarregar página
        // window.location.reload();
      }
    }

    // Log de erros em desenvolvimento
    if (import.meta.env.DEV) {
      console.error('BACKEND Axios Interceptou este Error:', error.response?.data || error.message);
      console.error('BACKEND Response Config:', error.response?.config);
      console.error('BACKEND Response Status:', error.response?.status);
      console.error('BACKEND Response Data:', error.response?.data);
    }
    return Promise.reject(error);
  }
);

export default api;